<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_BatchUpdateTitle1')"
    width="400px"
    :close-on-click-modal="false"
  >
    <div>
      <el-form label-position="left" label-width="100px">
        <el-form-item :label="''" label-width="10px">
          <el-radio-group v-model="form.listType" no="1">
            <el-radio :label="0">{{ $t('SystemMaintenance.BookingSuccessful') }}</el-radio>
            <el-radio :label="1">{{ $t('SeaExport.ToBeConfirmed') }}</el-radio>
            <el-radio :label="2">{{ $t('SeaExport.BookingFail') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="[0,1].includes(form.listType)">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.Vessel') }}</span>
            <cargo-advance-select
              no="5"
              :select-type="selectTypeNames.static_data_Vessel"
              :cache="false"
              filterable
              :allow-create="true"
              :default-value="form.shipName"
              :static-options="vesselList"
              style="width: 250px;"
              @parentCallBack="p=>{onVesselSelectionChange(p)}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.Voyage') }}</span>
            <cargo-advance-select
              ref="voyage"
              no="6"
              :static-options="voyages || []"
              :cache="false"
              :default-value="form.voyage"
              filterable
              clearable
              :allow-create="true"
              tag-name="voyageNo"
              tag-value="voyageNo"
              :filter-tag-names="['voyageNo']"
              style="width: 250px;"
              @focus="txtVoyageFocusInHandler()"
              @parentCallBack="p=>{onVoyageFlightChange(p)}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.PortOfLoading') }}</span>
            <cargo-advance-select
              ref="departurePort"
              no="departurePort"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="form.departurePort"
              tag-name="englishName"
              style="flex:1;width: 250px;"
              @parentCallBack="p=>{form.departurePort = p.value}"
            />&nbsp;
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.PortOfDischarge') }}</span>
            <cargo-advance-select
              no="dischargePort"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="form.dischargePort"
              style="width: 250px;"
              @parentCallBack="p=>{dischargingPortCodeChange(p.value);}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
            <el-date-picker
              no="etd"
              class="departure-date-picker"
              :value="form.etd"
              type="date"
              value-format="yyyy-MM-dd"
              style="flex: 1;margin-right: 5px; width: 250px;"
              @input="etdChange"
            />&nbsp;
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfArrival2')">
            <el-date-picker
              v-model="form.eta"
              no="eta"
              style="flex: 1;margin-right: 5px; width: 250px;"
              type="date"
              value-format="yyyy-MM-dd"
              @input="etaChange"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.ShippingCompany') }}</span>
            <cargo-company-select
              ref="shippingCompany"
              no="carrierId"
              :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
              :default-value="form.carrierId||''"
              style="display: inline-block;width:250px;"
              @change="p=>{form.carrierId=p.value;}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CabinSpaceNote')">
            <el-input
              v-model="form.allocationNote"
              no="allocationNote"
              type="textarea"
              :rows="4"
              style="width: 250px;"
            />
          </el-form-item>
          <el-form-item :label="''" label-width="10px">
            <el-radio-group v-model="form.fillType" no="3">
              <el-radio :label="0">{{ $t('CargoMsg.Cargo_FillSO') }}</el-radio>
              <el-radio :label="1">{{ $t('CargoMsg.Cargo_FillMBL') }}</el-radio>
              <el-radio :label="2">{{ $t('CargoMsg.Cargo_FillALL') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="S/O NO.">
            <el-input
              v-model="form.note"
              no="2"
              type="textarea"
              :rows="5"
              style="width: 250px;"
              @change="noteChangeHandler"
            />
            <div style="padding-left: 230px">{{ `(${notSize}/${list.length})` }}</div>
          </el-form-item>
          <el-form-item :label="''" label-width="10px">
            <span>{{ $t('CargoMsg.Cargo_WindowTip1') }}<br>{{ $t('CargoMsg.Cargo_WindowTip2') }}</span>
          </el-form-item>
        </div>
        <div v-if="form.listType === 2">
          <el-form-item :label="$t('CargoMsg.Cargo_CabinSpaceNote')">
            <el-input
              v-model="form.allocationNote"
              no="allocationNote"
              type="textarea"
              :rows="4"
              style="width: 250px;"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { getLoading4Cxt } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Voyage } from '@/class/model/mdm/Voyage'
import { cache, cacheName } from '@/utils/cacheManager'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import { loadSpecificBasicInfo } from '@/api/cache'
import { cabinUpdateFunc, checkDuplicateFunc } from '@/api/booking/cabinManagement'

export default {
  name: 'CabinSpaceBackWindow',
  components: { cargoCompanySelect, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    list: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: false,
      vesselList: [],
      voyages: [],
      seaPortList: [],
      regionList: [],
      vesselLine: '',
      currentVessel: null,
      showJudgmentOfVoyageNo: false, // 航次是否显示V.判断
      form: {
        listType: 0,
        shipName: '',
        voyage: '',
        departurePort: '',
        dischargePort: '',
        etd: null,
        eta: null,
        carrierId: 0,
        allocationNote: '',
        fillType: 0,
        placeOfDeliveryRegion: '',
        note: ''
      }
    }
  },
  computed: {
    notSize: {
      get() {
        return this.form.note ? this.form.note.split('\n').filter(line => line.trim()).length : 0
      },
      set(val) {
        return val
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (!newVal) {
        this.clearData()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    if (this.visible) {
      this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
      let oneKey = ''
      let err = false
      for (const data of this.list) {
        const key = data.shipName + '_' + data.voyage + '_' + data.departurePort + '_' +
          data.dischargePort + '_' + data.carrierId + '_' + data.etd
        if (oneKey && oneKey !== key) {
          err = true
        } else {
          oneKey = key
        }
      }
      // 勾选的舱单 指定的数据全部都一样
      if (!err) {
        const data = this.list[0]
        this.form.shipName = data.shipName
        this.form.voyage = data.voyage
        this.form.departurePort = data.departurePort
        this.form.dischargePort = data.dischargePort
        this.form.carrierId = data.carrierId
        this.form.etd = data.etd
      }
      this.innerVisible = true
    }
  },
  methods: {
    enterHandler() {
      if ([0, 1].includes(this.form.listType)) {
        if (!this.form.shipName) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.Vessel'))
          return
        }
        if (!this.form.voyage) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.Voyage'))
          return
        }
        if (!this.form.departurePort) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.PortOfLoading'))
          return
        }
        if (!this.form.dischargePort) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.PortOfDischarge'))
          return
        }
        if (!this.form.etd) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.DateOfDeparture2'))
          return
        }
        if (!this.form.carrierId) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.ShippingCompany'))
          return
        }
      }
      if (this.form.listType === 0) {
        const list = []
        if (this.form.note) {
          const l = this.form.note.trim().split('\n')
          for (const c of l) {
            if (c && c.trim()) {
              list.push(c.trim())
            }
          }
        }
        const soList = []
        const mblList = []
        for (const d of this.list) {
          if (d.soNo) {
            soList.push(d.soNo)
          }
          if (d.mblNo) {
            mblList.push(d.mblNo)
          }
        }
        const r = this.checkAndTips(list, soList, mblList)
        if (!r) {
          return
        }
      }
      if (this.form.note) {
        const containerDesc = this.list[0].boxTypeQuantity.split('\n')
        for (const data of this.list) {
          if (containerDesc && data.boxTypeQuantity) {
            const cmBox = data.boxTypeQuantity.split('\n')
            if (!this.compareLists(containerDesc, cmBox)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CheckDTip3'))
              return
            }
          }
        }
      }
      // this.fullscreenLoading = getLoading4Cxt()
      // const data = {
      //   fillType: this.form.fillType,
      //   note: this.form.note
      // }
      // checkDuplicateFunc(data).then(res => {
      //   const data = res.data
      //   if (data) {
      //     const { mblNo, soNo } = data
      //     if (mblNo || soNo) {
      //       let tip = ''
      //       if (mblNo) {
      //         tip += `MB/L${this.$t('CargoMsg.Cargo_DataRepetition')}[${mblNo}]`
      //       }
      //       if (soNo) {
      //         tip += tip ? `<br/>` : ''
      //         tip += `S/O${this.$t('CargoMsg.Cargo_DataRepetition')}[${soNo}]`
      //       }
      //       this.$message.warning({ dangerouslyUseHTMLString: true, message: tip })
      //     } else {
      this.doUpdate()
      //     }
      //   }
      // }).finally(() => {
      //   this.fullscreenLoading.close()
      // })
    },
    checkAndTips(list, soList, mblList) {
      const checkFillType = (fillType, targetList) => {
        const needNum = this.list.length - targetList.length
        if (needNum !== 0) {
          return this.tips(list)
        }
        return true
      }
      if (this.form.fillType === 0) {
        return checkFillType(this.form.fillType, soList)
      } else if (this.form.fillType === 1) {
        return checkFillType(this.form.fillType, mblList)
      } else {
        let r = checkFillType(this.form.fillType, soList)
        if (r) {
          r = checkFillType(this.form.fillType, mblList)
        }
        return r
      }
    },
    tips(list) {
      // 订舱成功填写MBL or SO
      if (!this.form.note) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_checkTip2', ['S/O', 'MBL']))
        return false
      }
      if (list.length !== this.list.length) {
        this.$message.warning(this.$t('CargoMsg.Cargo_QuantityInconsistency'))
        return false
      }
      return true
    },
    compareLists(listA, listB) {
      const sortedListA = listA.slice().sort()
      const sortedListB = listB.slice().sort()
      return sortedListA.length === sortedListB.length && sortedListA.every((value, index) => value === sortedListB[index])
    },
    doUpdate() {
      this.fullscreenLoading = getLoading4Cxt()
      const data = this.form
      data.uuids = this.list.map(data => data.uuid)
      cabinUpdateFunc(data).then(res => {
        this.$message.success(this.$t('SeaExport.OperationSucceeded'))
        this.$emit('confirmSync')
        this.close()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    txtVoyageFocusInHandler() {
      let value = 'V.'
      this.showJudgmentOfVoyageNo = Number(cache.config.get('JudgmentOfVoyageNo')) === 1
      if (!this.showJudgmentOfVoyageNo) {
        value = ''
      }
      if (this.form.voyage) {
        value = this.form.voyage
        this.form.voyage = ''
      }
      this.$nextTick(() => {
        this.form.voyage = value
        const elSelect = this.$refs.voyage.$refs.advanceSelectRef
        const innerInput = elSelect.$children[0].$refs.input
        innerInput.value = this.form.voyage
      })
    },
    async dischargingPortCodeChange(value) {
      const form = this.form
      if (form.dischargePort !== value) {
        form.dischargePort = value
        if (Number(cache.config.get('SyncPOD')) === 1) {
          form.deliveryPlace = form.dischargePort
        } else {
          form.deliveryPlace = form.deliveryPlace || form.dischargePort
        }
        const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
        const port = seaPorts.find(p => p.code === form.deliveryPlace)
        form.placeOfDeliveryRegion = port ? port.region : ''
      }
      this.checkVesselLine()
    },
    checkVesselLine() {
      const form = this.form
      this.vesselLine = ''
      if (form.dischargePort) {
        const port = this.seaPortList.find(p => p.code === form.dischargePort)
        if (port) {
          const region = this.regionList.find(p => p.code === port.region)
          this.vesselLine = region ? (this.$store.getters.language === 'zh' ? region.name : region.nameEnglish) : ''
        }
      }
    },
    async onVoyageFlightChange(data) {
      this.form.voyage = data.value
    },
    async onVesselSelectionChange(data) {
      this.currentVessel = data
      this.form.shipName = data.value
      await this.getVoyageByVessel()
    },
    async getVoyageByVessel() {
      if (this.currentVessel && this.currentVessel.vesselId) {
        this.voyages = await Voyage.getVoyage(this.currentVessel.vesselId)
      } else {
        this.voyages = []
      }
    },
    async etdChange(value) {
      this.form.etd = value
    },
    async etaChange(value) {
      this.form.eta = value
    },
    noteChangeHandler() {
      if (this.form.note) {
        const list = this.form.note.split('\n')
        this.notSize = list.length
      }
    },
    clearData() {
      this.form.listType = 0
      this.form.shipName = ''
      this.form.voyage = ''
      this.form.departurePort = ''
      this.form.dischargePort = ''
      this.form.etd = null
      this.form.eta = null
      this.form.carrierId = 0
      this.form.allocationNote = ''
      this.form.scNo = ''
      this.form.shipCallSign = ''
      this.form.fillType = ''
      this.form.placeOfDeliveryRegion = ''
      this.form.note = ''
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
